export var removeTopicIdFromString = function (topicId, topicString) {
    if (!topicString) {
        return;
    }
    return topicString
        .split(",")
        .filter(function (id) { return id !== topicId; })
        .join(",");
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/utils/topicHelpers.ts
// module id = B+kQ
// module chunks = 2